<template>
    <dx-grid
        url="scheduleDetails"
        :columns="columns"
        :title="title"
        :expandedOptions="{
            enabled: true,
            allowExpandingAll: true,
            template: 'schedule-details-expanded',
        }"
    ></dx-grid>
</template>

<script>
import moment from "moment";
import { formatCurrency } from "../utils/helpers.js";

export default {
    data: () => ({
        title: "Schedule Details",
        columns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                },
                icon: (value, row) => {
                    if (!value) return "";

                    if (!row.isEnabled) return "mdi-check-circle";

                    if (value.toUpperCase().startsWith("ERROR"))
                        return "mdi-alert-circle";

                    switch (value.toUpperCase()) {
                        case "APPROVED":
                            return "mdi-check-circle";
                        case "SCHEDULED":
                            return "mdi-clock";
                        case "DECLINED":
                            return "mdi-alert";
                        case "CANCELED":
                            return "mdi-close-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    if (!value) return "";

                    if (!row.isEnabled) return "success";

                    if (value.toUpperCase().startsWith("ERROR"))
                        return "#f35123";

                    switch (value.toUpperCase()) {
                        case "APPROVED":
                            return "success";
                        case "SCHEDULED":
                            return "#fdb400";
                        case "DECLINED":
                            return "#f35123";
                        case "CANCELED":
                            return "#aeb8bf";
                        default:
                            return "";
                    }
                },
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountID",
                format: "",
                template: "link-cell-template",
                link: (row) => {
                    return [
                        "DINNER WEB",
                        "DINNER IVR",
                        "DINNER PORTAL",
                        "Dinner App",
                    ].includes(row.source)
                        ? "DinnerAccountView"
                        : "Account View";
                },
                showLink: (row) => {
                    return true;
                },
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "scheduleDate",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "asc",
                sortIndex: 0,
                filterValues: [],
                filterValue: [new Date(), new Date(moment().add(1, "month"))],
                selectedFilterOperation: "between",
            },
            {
                label: "Created",
                field: "dateCreated",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                // sortOrder: "desc",
                // sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Amount",
                field: "amount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                type: "string",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Payment Type",
                field: "paymentType",
                type: "string",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source",
                field: "source",
                type: "string",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Attempts",
                field: "attempts",
                type: "number",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Enabled",
                field: "isEnabled",
                type: "boolean",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Card Type",
                field: "cardType",
                type: "string",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Card Ending",
                field: "cardNumLast5",
                type: "string",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Canceled By",
                field: "canceledBy",
                visible: false,
                type: "string",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated By",
                field: "userUpdated",
                visible: false,
                type: "string",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cancel Date",
                field: "cancelDate",
                type: "date",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Process Date",
                field: "processDate",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Updated",
                field: "lastUpdated",
                type: "date",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    methods: {},
};
</script>
<style></style>
